import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import IP_URL from '../Components/connect';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useDispatch } from 'react-redux';
import { loginSuccess, startLogoutTimer } from '../Redux/currentUserSlice';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Logo from '../Assets/logo.png'

// --- Styled components
const Main = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #1496d6;
  font-family: 'Poppins', sans-serif;
`;

const Form = styled.form`
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1);
  margin: 10px;
  width: 70%;
  max-width: 400px;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 1.5rem;
  color: #333;
  font-size: 1.8rem;
  font-weight: 600;
`;



const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;

  input {
    padding-left: 30px;
    border-radius: 5px;
    height: 40px;
    border: 1px solid #ccc;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 0.9rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  cursor: pointer;
  font-weight: 600;
`;

const Head = styled.h3`
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  font-size: 1.5rem;
  margin-bottom: 20px;
  position: relative;
  font-weight: 500;
`;

const LogoImg = styled.img`
 width: 40px;
 height: 40px;
 border-radius: 50%;
 background: white;
`

// --- Main Component
const Login = () => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogin = async (e) => {
    e.preventDefault();

     // 🔍 Basic validation before sending request
    if (!identifier || !password) {
      toast.error(" Please enter both phone number and password.", {
        position: "top-center",
        autoClose: 2500,
      });
      return;
    }
    setLoading(true);
   

    try {
      const response = await fetch(`${IP_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phoneNumber: identifier,
          password,
        }),
        credentials: 'include'
      });

      const data = await response.json();
   

      if (response.ok) {
        const userData = {
          uniqueKey: data.uniqueKey,
          username: data.username,
          role: data.accountType,
          email:data.email,
          token: data.token,
        };

        // ✅ store token + user data in Redux Persist
        dispatch(loginSuccess(userData));
        

          toast.success("✅ Login successful!", {
          position: "top-center",
          autoClose: 1500,
        });
        setTimeout(() => {
         
          switch (userData.role) {
            case 'super_admin':
              navigate('/admin-dashboard');
              break;
            case 'admin':
              navigate('/dashboard');
              break;
            case 'user':
              navigate(`/meter-details/${data.assignedMeter || ''}`);
              break;
            default:
              navigate('/');
          }
        }, 1500);
      } else {
            const message = data.message || "Invalid credentials. Please try again.";
        toast.error(` ${message}`, {
          position: "top-center",
          autoClose: 2000,
        });
      }
    } catch (err) {
      
        // 🌐 Network / Server error
      toast.error(" Network error. Please check your connection or try again later.", {
        position: "top-center",
        autoClose: 2000,
      });
    } finally {
      setLoading(false)
    }
  };

  return (
    <Main>
      <Head>
       <LogoImg src={Logo} />
        Aqua Smart Meter
      </Head>
   
      <Form onSubmit={handleLogin}>
        <Title>Login</Title>
     
        <InputContainer>
          <label>Phone Number:</label>
          <PhoneInput
            country="ke"
            value={identifier}
            onChange={setIdentifier}
            inputStyle={{
              width: '100%',
              paddingLeft: '30px',
              borderRadius: '5px',
              height: '40px',
              border: '1px solid #ccc',
            }}
            enableSearch
          />
        </InputContainer>

        <InputContainer>
          <label>Password:</label>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ flex: 1 }}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                marginLeft: '8px',
                padding: '4px 8px',
                cursor: 'pointer',
                background: 'none',
                border: 'none',
              }}
            >
              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </button>
          </div>
        </InputContainer>

          <Button type="submit" disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </Button>
      </Form>

      {/* Toast notification container */}
      <ToastContainer />
    </Main>
  );
};

export default Login;
